import { Component, OnInit, OnDestroy, ElementRef } from "@angular/core";
import { SharedService } from "../services/shared.service";
import { ApiService } from "../services/api.service";
import Typed from "typed.js";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import * as $ from "jquery";
import { MyAuthService } from "../authentication/auth.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"]
})
export class HomeComponent implements OnInit, OnDestroy {

  public companyThemesList = [];
  public showBenefits = false;
  public subscriptionBtnText = "Register";

  private typed: Typed;
  private routeSub: Subscription;

  constructor(
    public shared: SharedService,
    private _api: ApiService,
    private _auth: MyAuthService,
    private _toast: ToastrService,
    private _route: ActivatedRoute,
    private _myElement: ElementRef
  ) {
    // Fix: removed logoutUser() call — caused navigation loop on page load
    if (this.shared.userInfo && this.shared.userInfo.identity.role === 3) {
      this.subscriptionBtnText = "Subscribe";
    }

    // Fix: use .get() instead of param["params"]["showPlans"]
    this.routeSub = this._route.queryParamMap.subscribe(param => {
      if (param && param.get("showPlans") === "1") {
        this.showBenefits = true;
      }
    });
  }

  ngOnInit() {
    // Fix: store typed ref for cleanup
    this.typed = new Typed("#typing1", {
      strings: [
        "Financial goals (e.g., kid's education)",
        "Retirement Planning",
        "Wealth creation"
      ],
      typeSpeed: 150,
      backSpeed: 30,
      showCursor: true,
      cursorChar: "",
      loop: true
    });

    this.homeSettings();

    // Fix: wait for DOM before scrolling
    if (this.showBenefits) {
      setTimeout(() => this.scrollToView(), 300);
    }

    this.getThemeDetails();
  }

  ngOnDestroy() {
    // Fix: cleanup typed.js to prevent memory leak
    if (this.typed) {
      this.typed.destroy();
    }
    // Fix: unsubscribe to prevent memory leak
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  getThemeDetails() {
    this._api.getThemes().subscribe(
      result => {
        this.companyThemesList = result;
      },
      err => {
        console.error("Error fetching themes", err);
      }
    );
  }

  openLogin(regType) {
    if (this.shared.userInfo) {
      if (this.shared.userInfo.identity.role === 3 && regType === 1) {
        this._toast.error("You are already registered user!");
      } else if (this.shared.userInfo.identity.role === 3 && regType === 2) {
        this.subscribeToPlans();
      } else if (
        this.shared.userInfo.identity.role === 2 ||
        this.shared.userInfo.identity.role === 0
      ) {
        this._toast.error("You are already subscribed user!");
      }
    } else {
      this.shared.toggleLoginRegisterModal(regType, 1);
      this.shared.goToRoute("/authentication/login", 0);
    }
  }

  homeSettings() {
    let maxHeight = 0;
    $(".sameHeight .sameCol").each(function () {
      if ($(this).height() > maxHeight) {
        maxHeight = $(this).height();
      }
    });
    $(".sameHeight .sameCol").height(maxHeight);

    $(".chooseSameCol .sameCol").each(function () {
      if ($(this).height() > maxHeight) {
        maxHeight = $(this).height();
      }
    });
    $(".chooseSameCol .sameCol").height(maxHeight);
  }

  subscribeToPlans() {
    this._api.subscribePlans().subscribe(
      response => {
        if (response.repsonseType === "success") {
          this._toast.success(
            "Your request has been captured. Our team will get back to you."
          );
        }
      },
      err => {
        this._toast.error("Oops, something went wrong! Please try again later.");
      }
    );
  }

  investNow() {
    // Fix: null check before accessing properties
    if (!this.shared.userInfo) {
      this.shared.goToRoute("authentication/login", 0);
      return;
    }
    if (this.shared.userInfo.type_of === "partner") {
      this.shared.goToRoute("user/my-dashboard", 0);
    } else {
      this.shared.goToRoute("user/my-dashboard/watchlist", 0);
    }
  }

  scrollToView() {
    const benefits = this._myElement.nativeElement.ownerDocument.getElementById(
      "benifits-pricing"
    ) as HTMLElement;
    if (benefits instanceof HTMLElement) {
      benefits.scrollIntoView({ behavior: "smooth" });
    }
  }
}